
export const host = 'https://grapi.bpspurnea.com/';